import { APP_API } from 'src/utils/constants';
import HttpClient from './http';

const getActiveRaffles = (params: { operatorId: number }): Promise<any> => {
  return HttpClient.get(
    {
      path: `${APP_API}/getActiveRaffles`,
      baseURL: process.env.REACT_APP_GAME_BOX as string,
    },
    false,
    params
  );
};

const getActiveRafflesTickets = (): Promise<any> => {
  return HttpClient.get({
    path: `${APP_API}/getActiveRafflesTickets`,
    baseURL: process.env.REACT_APP_GAME_BOX as string,
  });
};

const getPrizeStructures = (params: { id: number }): Promise<any> => {
  return HttpClient.get(
    {
      path: `${APP_API}/getPrizeStructures`,
      baseURL: process.env.REACT_APP_GAME_BOX as string,
    },
    false,
    params
  );
};
const getOnlyExpireTimePassedRaffles = (params: {
  onlyExpireTimePassed: boolean;
  operatorId: number;
}): Promise<any> => {
  return HttpClient.get(
    {
      path: `${APP_API}/getRaffles`,
      baseURL: process.env.REACT_APP_GAME_BOX as string,
    },
    false,
    params
  );
};
const getFinishedRafflePrizes = (params: { raffleId: number }): Promise<any> => {
  return HttpClient.get(
    {
      path: `${APP_API}/getFinishedRafflePrizes`,
      baseURL: process.env.REACT_APP_REPORTS as string,
    },
    false,
    params
  );
};

export {
  getActiveRaffles,
  getActiveRafflesTickets,
  getFinishedRafflePrizes,
  getOnlyExpireTimePassedRaffles,
  getPrizeStructures,
};
